import config from '../config';
import * as actions from '../actions/checkIn';
import fetch from 'cross-fetch';
import { push } from 'react-router-redux';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { ACTIVITY_STATUS } from '../reducers/checkIn';
import {makeTimestampForLocationTimeZoneByTime} from "../utils/date";

export function fetchAllActivities() {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetchUrl('timeTracking/lookupActivities')
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(actions.loadAllActivities({
                            activities: json
                        }));
                    }
                })
                .catch(response => dispatch(actions.loadAllActivitiesFailed({ error: response })));
        }
    }
};

export function fetchCustomers() {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetchUrl('timeTracking/getCustomers')
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(actions.loadCustomers({
                            customers: json
                        }));
                    }
                })
                .catch(response => dispatch(actions.loadCustomersFailed({ error: response })));
        }
    }
};

export function fetchWorkOrders(customerID) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            dispatch(actions.loadWorkOrders({ workOrders: null }));
            const queryParams = customerID ? `customer_id=${customerID}&only_active=1` : `only_active=1`;
            return fetchUrl(`dashboard/tasks?${queryParams}`)
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(actions.loadWorkOrdersSuccess({
                            workOrders: json.tasks
                        }));
                    }
                })
                .catch(response => dispatch(actions.loadWorkOrdersFailed({ error: response })));
        }
    }
};

export function getUserCheckIn(userId) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetchUrl(`timeTracking/login/${userId}`)
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(actions.getUserCheckin({
                            activeCheckin: json
                        }));
                    }
                })
                .catch(response => dispatch(actions.getUserCheckinFailed({ error: response })));
        }
    }
};

export function checkInUser(userId) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetch(`${config.apiEndpoint}/timeTracking/checkin/${userId}`, {
                method: 'POST',
                headers: {
                    'Authorization': `bearer ${userAuth.api_token}`
                },
                credentials: 'same-origin',
            })
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(actions.checkInUser({
                            userCheckIn: json
                        }));
                    }
                })
                .catch(response => dispatch(actions.checkInUserFailed(response)));
        }
    }
}

export function checkOutUser(userId) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetch(`${config.apiEndpoint}/timeTracking/checkout/${userId}`, {
                method: 'POST',
                headers: {
                    'Authorization': `bearer ${userAuth.api_token}`
                },
                credentials: 'same-origin',
            })
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(notify({
                            title: 'User Check out',
                            message: 'Check out Successful',
                            status: 'success',
                            position: 'tr',
                            dismissible: true,
                            dismissAfter: 3000
                        }));
                        dispatch(push('/pages/check-in'));
                    }
                });
        }
    }
}


export function checkOutEmployees() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/timeTracking/checkout-employees`, {
        method: 'POST',
        headers: {
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin',
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            // console.log(json)
            dispatch(notify({
              title: 'Users Check out',
              message: 'Check out Successful',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            dispatch(push('/pages/check-in'));
          }
        });
    }
  }
}

export function startActivity(formData) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetch(`${config.apiEndpoint}/timeTracking/startActivity`, {
                method: 'POST',
                headers: {
                    'Authorization': `bearer ${userAuth.api_token}`
                },
                credentials: 'same-origin',
                body: formData,
            })
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json && json.code !== 404) {
                        dispatch(notify({
                            title: 'Start Activity',
                            message: 'Work Started',
                            status: 'success',
                            position: 'tr',
                            dismissible: true,
                            dismissAfter: 3000
                        }));
                        dispatch(push('/pages/check-in'));
                    } else {
                        dispatch(notify({
                            title: 'Start Activity',
                            message: json.detail,
                            status: 'error',
                            position: 'tr',
                            dismissible: true,
                            dismissAfter: 3000
                        }));
                    }
                })
                .catch(response => dispatch(actions.startActivity({ error: response })));
        }
    }
}

export function getCurrentActivity(userId) {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetchUrl(`timeTracking/getActivity/${userId}`)
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        dispatch(actions.getCurrentActivity({
                            currentActivity: json
                        }));
                    }
                });
        }
    }
};

export function updateActivityStatus(activityId, status) {
    switch (status) {
        case ACTIVITY_STATUS.PAUSE:
            return updateActivity(`${config.apiEndpoint}/timeTracking/pauseActivity/${activityId}`, activityId, status);
        case ACTIVITY_STATUS.RESUME:
            return updateActivity(`${config.apiEndpoint}/timeTracking/resumeActivity/${activityId}`, activityId, status);
        case ACTIVITY_STATUS.STOP:
            return updateActivity(`${config.apiEndpoint}/timeTracking/finishActivity/${activityId}`, activityId, status);
        default:
            return;
    }
}


const updateActivity = (url, activityId, status) => {
    return (dispatch) => {
        const userAuth = store.get('user');
        if (userAuth && userAuth.api_token) {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Authorization': `bearer ${userAuth.api_token}`
                },
                credentials: 'same-origin',
            })
                .then((response) => {
                    return response.json();
                })
                .then(json => {
                    if (json) {
                        let messageVerb = '';
                        switch (status) {
                            case ACTIVITY_STATUS.RESUME:
                                messageVerb = 'Resumed';
                                break;
                            case ACTIVITY_STATUS.PAUSE:
                                messageVerb = 'Paused';
                                break;
                            case ACTIVITY_STATUS.STOP:
                                messageVerb = 'Stopped';
                                break;
                            default:
                                messageVerb = 'Started';

                        };
                        dispatch(actions.updateActivity({ activityId, status }));
                        dispatch(notify({
                            title: 'Activity Updated',
                            message: `Work ${messageVerb}`,
                            status: 'success',
                            position: 'tr',
                            dismissible: true,
                            dismissAfter: 3000
                        }));
                    }
                });
        }
    }
}

export function createActivity(data, callback = null) {
  return dispatch => {
    const userAuth = store.get('user');
    const { started_at, stopped_at, customer, worker, wo_number, activity} = data;
    return fetch(`${config.apiEndpoint}/timeTracking/activity`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        started_at: makeTimestampForLocationTimeZoneByTime(started_at),
        stopped_at: makeTimestampForLocationTimeZoneByTime(stopped_at),
        customer,
        worker,
        wo_number,
        activity
      })
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {

          if (typeof callback === 'function') {
            callback();
          }

          if (json.code == 400) {
            dispatch(notify({
              title: json.title,
              message: json.detail,
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else {
            dispatch(notify({
              title: 'Create activity',
              message: 'Activity created successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        }
      }
    );
  }
};


export function updateActivityDuration(data, callback = null) {
  return dispatch => {
    const userAuth = store.get('user');
    const { started_at, stopped_at, activity, customer, worker, wo_number} = data;
    return fetch(`${config.apiEndpoint}/timeTracking/activity/${data.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        started_at: makeTimestampForLocationTimeZoneByTime(started_at),
        stopped_at: makeTimestampForLocationTimeZoneByTime(stopped_at),
        activity,
        customer,
        worker,
        wo_number
      })
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {

          if (typeof callback === 'function') {
            callback();
          }

          if (json.code === 400) {
            dispatch(notify({
              title: 'Work Order',
              message: 'Work order does not exist',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else {
            dispatch(notify({
              title: 'Update activity',
              message: 'Activity updated successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        }
      });
  }
};

export function updateCheckinWorkday(data, callback = null) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/checkin/${data.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin',
      body: JSON.stringify({workday: data.duration})
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {

          if (typeof callback === 'function') {
            callback();
          }

          dispatch(notify({
            title: 'Update checkin',
            message: 'Checkin updated successfully',
            status: 'success',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));

        }
      });
  }
};

export function deleteActivity(data, callback = null) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/activity/${data.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {

          if (typeof callback === 'function') {
            callback();
          }

          dispatch(notify({
            title: 'Delete activity',
            message: 'Activity deleted successfully',
            status: 'success',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        }
      });
  }
};

export function deleteCheckin(data, callback = null) {
  return dispatch => {
    const userAuth = store.get('user');
    return fetch(`${config.apiEndpoint}/timeTracking/checkin/${data.id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `bearer ${userAuth.api_token}`
      },
      credentials: 'same-origin'
    })
      .then((response) => {
        return response.json();
      })
      .then(json => {
        if (json) {

          if (typeof callback === 'function') {
            callback();
          }

          dispatch(notify({
            title: 'Delete checkin',
            message: 'Checkin deleted successfully',
            status: 'success',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        }
      });
  }
};

const fetchUrl = (url, method = 'GET', data) => {
    return fetch(`${config.apiEndpoint}/${url}`, {
        method,
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${store.get('user').api_token}`
        },
        credentials: 'same-origin'
    })
};



// WEBPACK FOOTER //
// ./src/api/checkIn.js